<template lang="">
    <v-container>
        <!-- Logeado con el usuario "{{usuarioLogeado}}" -->
        <v-card>
            <v-card-title>
                Gestión de Usuarios
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" hide-details single-line></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="usuarios" :search="search">
                <template v-slot:top>
                    <v-toolbar flat>
                    <v-toolbar-title>Todos los usuarios</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px" v-if=permiso_admin>
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                            <v-icon class="mr-2"> mdi-account-plus </v-icon>
                            Crear nuevo usuario
                        </v-btn>
                        </template>
                        <v-card>
                        <v-card-title>
                            <span class="text-h5"> {{formTitle}} </span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col>
                                        <v-text-field 
                                            v-model="editedItem.nombre" 
                                            label="Nombre" 
                                            :rules="[rules.required, rules.min4]" 
                                            required>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-select :items="roles" item-text="rol" item-value="id" v-model="editedItem.id_rol" label="Permiso"></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field 
                                            v-model="contraseña" 
                                            label="Contraseña" 
                                            :rules="[rules.required, rules.min8]"
                                            :append-icon="show_Contraseña ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show_Contraseña ? 'text' : 'password'"
                                            @click:append="show_Contraseña = !show_Contraseña"
                                            counter>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field 
                                            v-model="contraseña_confirm" 
                                            label="Confirmar contraseña" 
                                            :rules="[rules.required, rules.min8]"
                                            :append-icon="show_Contraseña_confirm ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show_Contraseña_confirm ? 'text' : 'password'"
                                            @click:append="show_Contraseña_confirm = !show_Contraseña_confirm"
                                            counter>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <!-- Las acciones -->
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">
                            Cancelar
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="save">
                            Guardar
                            </v-btn>
                        </v-card-actions>
                        </v-card>
                    </v-dialog>
                    </v-toolbar>
                </template>
                
                <template v-slot:item.actions="{ item }" v-if="permiso_admin">
                    <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
        <v-spacer></v-spacer>
        <div v-if="mensaje != ''">
            <br>
            <p class="red--text">{{mensaje}}</p>
        </div>
    </v-container>
</template>
<script>
import {mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'
export default {
    data(){
        return {
            dialog: false,
            contraseña: '',
            contraseña_confirm: '',
            show_Contraseña: false,
            show_Contraseña_confirm: false,
            mensaje: '',
            permiso_admin: false,
            editedItem: {
                id: -1,
                nombre: '',
                id_rol: -1,
            },
            rules: {
                required: value => !!value || 'Campo Obligatorio',
                min8: v => v.length >= 8 || 'Min 8 caracteres',
                min4: v => v.length >= 4 || 'Min 4 caracteres',
            },
            headers: [
                {text:"USUARIO", align:"center", value:"name"},
                {text:"PERMISO", align:"center", value:"rol"},
            ],
            usuarios: [],
            roles: [],
            search: '',
        }
    },
    computed: {
        ...mapState([
            'usuarioLogeado',
        ]),
        formTitle(){
            return this.editedItem.id === -1 ? 'Nuevo usuario' : 'Editar usuario'
        }
    },
    watch: {
        dialog(val) {
            val || this.close() //Ejecutado cuando clicamos fuera del dialogo
        },
    },
    methods: {
        ...mapActions(['getData','postData','putData']),
        close() {
            this.dialog = false
            this.editedItem.id = -1
            this.editedItem.id_rol = -1
            this.editedItem.nombre = ''
            this.clean()
        },
        async save(){
            if(this.editedItem.id == -1){ //Entramos cuando creamos un item nuevo
                //Comprobación relleno de campos
                if(this.contraseña == '' || this.contraseña_confirm == '' || this.editedItem.nombre == '' || this.editedItem.id_rol < 1){
                    this.alerta_error('Rellena todos los campos!')
                }else{
                    //Contraseñas no coinciden
                    if(this.contraseña != this.contraseña_confirm || this.editedItem.nombre.length < 4 || this.contraseña.length < 8){
                        this.alerta_error('Los campos introducidos no cumplen los requisitos necesarios')
                    }else{
                        //Comprobar nombre usuario no existe
                        // let users = await this.axios.get('/users')
                        const payload = {
                            path: 'login/users',
                            params:{}
                        }
                        let users = await this.getData(payload)
                        let find = users.find(item => item.name == this.editedItem.nombre)
                        if(typeof(find) != 'undefined'){
                            this.alerta_error('Existe un usuario con el nombre indicado, elija otro nombre')
                        }else{
                            //Introducir usuario
                            let user = {usuario: this.editedItem.nombre, password: this.contraseña, id_rol: this.editedItem.id_rol}
                            // this.axios.post('/register', user)
                            const payload = {
                                path:'login/register',
                                body:{
                                    usuario: this.editedItem.nombre,
                                    password: this.contraseña,
                                    id_rol: this.editedItem.id_rol
                                }
                            }

                            this.postData(payload)
                            .then(respuesta => {
                                Swal.fire(
                                'Creado!',
                                'Usuario introducido correctamente',
                                'success'
                                )
                                this.obtenerUsuarios()
                            })
                            .catch(e => {
                                this.mensaje = e.response.message
                            })
                        }
                    }
                }
            }else{ //Entramos cuando editamos un item
                if(this.contraseña == '' || this.contraseña_confirm == '' || this.editedItem.nombre == ''){
                    this.alerta_error('Rellena todos los campos!')
                }else{
                    //Contraseñas no coinciden
                    if(this.contraseña != this.contraseña_confirm || this.editedItem.nombre.length < 4 || this.contraseña.length < 8){
                        this.alerta_error('Los campos introducidos no cumplen los requisitos necesarios')
                    }else{
                        let user = {usuario: this.editedItem.nombre, password: this.contraseña, id_rol: this.editedItem.id_rol}
                        // await this.axios.put(`/users/${this.editedItem.id}`, user)
                        const payload = {
                            path: 'login/users',
                            params:this.editedItem.id,
                            body:user
                        }
                        this.putData(payload)
                        .then(respuesta => {
                            //a
                            Swal.fire({
                                icon:'success',
                                title: 'Aceptada!',
                                text: 'Usuario editado con exito',
                            })
                            this.obtenerUsuarios()
                        }).catch(e => {
                            this.mensaje = e.response.message
                        })
                        
                        
                        
                        .then(respuesta => {
                            //a
                            Swal.fire({
                                icon: 'success',
                                title: 'Aceptada!',
                                text: 'Usuario editado con exito',
                            })
                            this.obtenerUsuarios()
                        }).catch(e => {
                            this.mensaje = e.response.data.message
                        })
                    }
                }
            }
            this.clean()
            this.close()
        },
        clean(){
            this.editedItem.nombre = ''
            this.editedItem.id_rol = -1
            this.contraseña = ''
            this.contraseña_confirm = ''
        },
        alerta_error(texto='Ha habido un error'){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: texto,
            })
        },
        async obtenerUsuarios(){
            // let data = await this.axios.get('/users')
            const payload = {
                path: 'login/users',
                params:{}
            }
            let data = await this.getData(payload)
            console.log(data)
            this.usuarios = data
        },
        deleteItem(item){
            Swal.fire({
                title: 'Seguro que quieres borrar el usuario?',
                text: "Una vez eliminado no podras recuperarlo!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminalo!',
                cancelButtonText: 'Cancelar'
                }).then(async(result) => {
                if (result.isConfirmed) {
                    // await this.axios.put(`/user/${item.id}`)
                    const payload = {
                        path: 'login/user',
                        params:item.id,
                        body:{}
                    }
                    await this.putData(payload)
                    .then(respuesta => {
                        Swal.fire(
                        'Eliminado!',
                        'El usuario a sido eliminado.',
                        'success'
                        )
                        this.obtenerUsuarios()
                    })
                }
            })
        },
        editItem(item){
            this.editedItem.id = item.id
            this.editedItem.nombre = item.name
            this.editedItem.id_rol = item.id_rol
            this.dialog = true
        },
        async obtenerRoles(){
            // let data = await this.axios.get('/roles')
            const payload = {
                path: 'login/roles',
                params:{}
            }
            this.roles= await this.getData(payload)
            
            // this.roles = data.data
        },
        permisosUsuario(){
            if(localStorage.getItem('id_rol') == 1){ // Solo rol administrador
                this.permiso_admin = true
                this.headers = [
                    {text:"USUARIO", align:"center", value:"name"},
                    {text:"PERMISO", align:"center", value:"rol"},
                    {text:"OPCIONES", align:"center", sortable: false, value:"actions"},
                ]
            }else{
                this.permiso_admin = false
            }
        },

    }, //FIN methods

    created(){
        this.obtenerUsuarios()
        this.obtenerRoles()
        this.permisosUsuario()
    },
}
</script>
<style>
</style>